/* ═══════════════════════════════════════════════════════════
   DARF — Cookie consent banner (DSGVO)
   - Persists choice in localStorage (key: darf_consent_v1)
   - Propagates to Shopify Customer Privacy API when available
   - Re-openable via [data-cookie-open] or hash #cookie-settings
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var STORAGE_KEY = 'darf_consent_v1';
  var banner      = document.getElementById('darf-cookie');
  if (!banner) return;

  var bannerView   = banner.querySelector('[data-cookie-view="banner"]');
  var settingsView = banner.querySelector('[data-cookie-view="settings"]');
  var checkboxes   = banner.querySelectorAll('input[data-consent]');

  function loadConsent() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)); }
    catch (_) { return null; }
  }

  function saveConsent(consent) {
    consent.timestamp = Date.now();
    consent.version   = 1;
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(consent)); } catch (_) {}
    propagateShopify(consent);
    document.dispatchEvent(new CustomEvent('darf:consent', { detail: consent }));
  }

  function propagateShopify(consent) {
    var P = window.Shopify && window.Shopify.customerPrivacy;
    if (!P || typeof P.setTrackingConsent !== 'function') return;
    P.setTrackingConsent({
      analytics:    !!consent.analytics,
      marketing:    !!consent.marketing,
      preferences:  !!consent.preferences,
      sale_of_data: !!consent.marketing
    }, function () {});
  }

  function openBanner() {
    bannerView.hidden = false;
    settingsView.hidden = true;
    banner.hidden = false;
  }

  function openSettings() {
    var current = loadConsent() || {};
    checkboxes.forEach(function (cb) {
      cb.checked = !!current[cb.dataset.consent];
    });
    bannerView.hidden = true;
    settingsView.hidden = false;
    banner.hidden = false;
  }

  function close() {
    banner.hidden = true;
  }

  function acceptAll() {
    saveConsent({ analytics: true, marketing: true, preferences: true });
    close();
  }

  function rejectAll() {
    saveConsent({ analytics: false, marketing: false, preferences: false });
    close();
  }

  function saveCustom() {
    var consent = {};
    checkboxes.forEach(function (cb) {
      consent[cb.dataset.consent] = cb.checked;
    });
    saveConsent(consent);
    close();
  }

  banner.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cookie-action]');
    if (!btn) return;
    switch (btn.dataset.cookieAction) {
      case 'accept-all':    acceptAll(); break;
      case 'reject':        rejectAll(); break;
      case 'settings':      openSettings(); break;
      case 'close-settings':
        if (loadConsent()) close(); else openBanner();
        break;
      case 'save':          saveCustom(); break;
    }
  });

  /* External re-open trigger */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cookie-open]');
    if (trigger) { e.preventDefault(); openSettings(); }
  });

  if (window.location.hash === '#cookie-settings') openSettings();

  /* Initial display */
  var stored = loadConsent();
  if (!stored) {
    openBanner();
  } else {
    propagateShopify(stored);
  }
})();
